import React from "react";
import { Globe, ChevronDown } from "lucide-react";
import { useCurrency } from "../../context/CurrencyContext";

// Compact currency picker. `variant="dark"` for light text over dark banners.
export default function CurrencySelector({ variant = "light", className = "" }) {
  const { currency, setCurrency, supported } = useCurrency();
  const dark = variant === "dark";
  return (
    <label
      data-testid="currency-selector"
      className={`relative inline-flex items-center gap-2 rounded-full border px-3 py-2 text-sm font-semibold cursor-pointer transition-colors ${
        dark ? "bg-night/70 border-cream/25 text-cream hover:border-gold backdrop-blur" : "bg-cream border-parchment text-ink hover:border-gold"
      } ${className}`}
    >
      <Globe className="w-4 h-4 text-gold shrink-0" />
      <select
        value={currency}
        onChange={(e) => setCurrency(e.target.value)}
        data-testid="currency-select"
        aria-label="Choose display currency"
        className="appearance-none bg-transparent pr-4 outline-none cursor-pointer"
      >
        {supported.map((c) => (
          <option key={c.code} value={c.code} label={`${c.code} — ${c.name}`} />
        ))}
      </select>
      <ChevronDown className="w-4 h-4 opacity-70 -ml-4 pointer-events-none shrink-0" />
    </label>
  );
}
